import React, { useState } from 'react';
import {
  Card,
  Table,
  Button,
  InputNumber,
  Space,
  message,
} from 'antd';
import {
  ReloadOutlined,
} from '@ant-design/icons';

// 游戏类型列表
const GAME_TYPES = [
  { code: 'SPORTS', name: '体育' },
  { code: 'LIVE_DEALER', name: '真人视讯' },
  { code: 'LIVE', name: '直播' },
  { code: 'ELECTRONIC', name: '电子' },
  { code: 'FISHING', name: '捕鱼' },
  { code: 'LOTTERY', name: '彩票' },
  { code: 'CARD', name: '棋牌' },
  { code: 'COCKFIGHT', name: '斗鸡' },
];

interface VipRebateData {
  vipLevel: number;
  vipName: string;
  rebates: Record<string, number>; // 场馆编码 -> 返水比例
}

// 初始化数据 - 11个VIP等级（VIP0-VIP10）
const initialRebateData: VipRebateData[] = Array.from({ length: 11 }, (_, i) => {
  const rebates: Record<string, number> = {};
  GAME_TYPES.forEach(type => {
    // 初始返水比例：VIP0为0.002，每级递增0.0005
    rebates[type.code] = i === 0 ? 0.002 : 0.002 + i * 0.0005;
  });
  return {
    vipLevel: i,
    vipName: `VIP${i}`,
    rebates,
  };
});

const VipRebateConfig: React.FC = () => {
  const [rebateData, setRebateData] = useState<VipRebateData[]>(initialRebateData);

  const handleRebateChange = (vipLevel: number, gameTypeCode: string, value: number | null) => {
    setRebateData(prev =>
      prev.map(item =>
        item.vipLevel === vipLevel
          ? {
              ...item,
              rebates: {
                ...item.rebates,
                [gameTypeCode]: value ?? 0,
              },
            }
          : item
      )
    );
  };

  const handleSave = () => {
    message.success('VIP返水配置已保存');
  };

  const handleReset = () => {
    setRebateData(initialRebateData);
    message.info('已重置为初始数据');
  };

  // 构建表格列
  const columns = [
    {
      title: 'VIP等级',
      dataIndex: 'vipLevel',
      key: 'vipLevel',
      width: 100,
      fixed: 'left' as const,
      align: 'center' as const,
      render: (level: number) => (
        <div style={{ fontWeight: 'bold' }}>{level}</div>
      ),
    },
    {
      title: '等级名称',
      dataIndex: 'vipName',
      key: 'vipName',
      width: 120,
      fixed: 'left' as const,
      render: (name: string) => (
        <div style={{ fontWeight: 'bold' }}>{name}</div>
      ),
    },
    ...GAME_TYPES.map(type => ({
      title: type.name,
      key: type.code,
      width: 120,
      align: 'center' as const,
      render: (_: any, record: VipRebateData) => (
        <InputNumber
          value={record.rebates[type.code]}
          onChange={(value) => handleRebateChange(record.vipLevel, type.code, value)}
          min={0}
          max={1}
          step={0.0001}
          precision={4}
          style={{ width: '100%' }}
          formatter={(value) => `${value ?? 0}`}
        />
      ),
    })),
  ];

  return (
    <div style={{ padding: 24 }}>
      <div className="page-header">
        <h1>VIP返水配置</h1>
        <p>配置各VIP等级在不同游戏类型的返水比例</p>
      </div>

      <Card>
        <Space style={{ marginBottom: 16 }}>
          <Button icon={<ReloadOutlined />} onClick={() => message.info('缓存查询成功')}>
            缓存查询
          </Button>
          <Button onClick={handleReset}>
            重置
          </Button>
          <Button danger onClick={() => message.success('缓存已清除')}>
            清除
          </Button>
        </Space>

        <Table
          rowKey="vipLevel"
          dataSource={rebateData}
          columns={columns}
          pagination={false}
          scroll={{ x: 1500 }}
          bordered
        />

        <Space style={{ marginTop: 16 }}>
          <Button onClick={handleReset}>
            重置
          </Button>
          <Button type="primary" onClick={handleSave}>
            确认
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default VipRebateConfig;

